export default {
  en: {
    title: 'Trends',
    loadingCharts: 'Loading charts',
  },
  ru: {
    title: 'Динамика',
    loadingCharts: 'Загружаю графики',
  },
  de: {
    title: 'Trends',
    loadingCharts: 'Diagramme werden geladen',
  },
  pt: {
    title: 'Tendências',
    loadingCharts: 'Carregando gráficos',
  },
  fr: {
    title: 'Tendances',
    loadingCharts: 'Chargement des graphiques',
  },
  es: {
    title: 'Tendencias',
    loadingCharts: 'Cargando gráficos',
  },
};
